/**
 * Gameplay-related constants shared across Nova projects.
 */

/**
 * RGB color values for team coloring of spine skeleton slots at runtime.
 * Array index corresponds to team id.
 *
 * Note: These values differ from GameplayTeamColourShaderTints (in game-server)
 * which are used for shader-based tinting on grey assets.
 */
export const TeamIdAndColorMap = [
  [57 / 255, 210 / 255, 1.0], // ally (teal)
  [1.0, 0.25, 0.25], // enemy (red)
  [1.0, 1.0, 0.25], // 3rd team (yellow)
  [0.25, 1.0, 0.25] // 4th team (green)
] as const;
